<template>
  <footer class="w-100 text-center mt-4 mb-2">
    <p><router-link to="/"><b>Qintro</b></router-link> by <b><a href="https://www.c2native.io" target="_blank">C2 Native</a></b>.<br>
    Copyright &copy; {{copyYear}} <a href="https://www.c2native.io" target="_blank"><b>C2 Native</b></a>. All Rights Reserved.</p>
    <p>| <router-link to="/privacy-policy" class="text-primary">Privacy Policy</router-link> |</p>
  </footer>
</template>

<script>
export default {
  computed: {
    copyYear: function() {
      const date = new Date();
      return date.getFullYear();
    },
  }
}
</script>

<style>
  footer {
    font-size: 0.75em;
  }
</style>